var Acr = Acr || {};

Acr.Nav = function () {

  var utility = window.Utility;

  var $element;
  var $body;
  var $toggleDropDown;
  var $navDropDown;
  var $searchForm;
  var $searchSubmitBtn;
  var $geoForm;
  var $geoZipInput;
  var $geoZipButton;
  var $currentZip;
  var $navSearch;
  var $navActionContainer;
  var zipcodeUpdateEvent;
  var observer;
  var $acrNotificationContainer;
  var $acrNotificationPagination;
  var $acrNotificationBannerItems;
  var $arrowRight;
  var $arrowLeft;
  var $acrNotificationBannerSwiper;

  const currentOfferEndpoint = Acr.currentOfferEndPoint;
  const zipcodeUpdateEventName = 'zipcodeUpdate';
  const bodyTagSelector = 'body';
  const navDropdownClassSelector = '.js-nav-dropdown';
  const toggleDropDownClassSelector = '.js-toggle-dropdown';
  const toggleLangChooserBtnSelector = '.js-lang-chooser-btn';
  const searchBtnSelector = '.js-search-btn';
  const geoBtnSelector = '.js-geo-btn';
  const shadowSelector = '.js-shadow';
  const currentZipSelector = '.js-current-zip';
  const searchFormSelector = '.js-search-form';
  const searchSubmitBtnSelector = '.js-acr-nav-search-submit';
  const openZipGateSelector = '.js-open-zipgate';
  const geoFormSelector = '.js-geo-form';
  const toggleBarClassSelector = '.js-toggle-btn';
  const acrNavInputSelector = '.js-search-form input';
  const acrNavGeoInputSelector = '.js-geo-form input';
  const acrNavGeoButtonSelector = '.js-geo-form button';
  const navSearchSelector = 'nav-search';
  const acrNavActionContainerSelector = '.acr-nav__action-container';
  const acrNavGeoErrorClassName = 'acr-nav--geo-error';
  const noValidClassName = 'no-valid';
  const acrNavShadowClassName = 'acr-nav--shadow-visible';
  const modalOpenClassName = 'modal-open';
  const noScrollSmall = 'no-scroll-small';
  const acrNavExpandedClassName = 'acr-nav--opened';
  const acrNavSearchExpandedClassName = 'acr-nav--search-opened';
  const acrNavGeoExpandedClassName = 'acr-nav--geo-opened';
  const acrNavLangExpandedClassName = 'acr-nav-lang-chooser--expanded';
  const acrNavItemLinkExpandedClassName = 'acr-nav__item-link--expanded';
  const acrNavDropdownExpandedClassName = 'acr-nav__dropdown--expanded';
  const arrowRightSelector = '.js-arrow-right';
  const arrowLeftSelector = '.js-arrow-left';
  const acrNotificationPaginationSelector = '.js-swiper-pagination';
  const acrNotificationContainerSelector = '.js-swiper-container';
  const acrNotificationBannerItemSelector = '.js-acr-notification-banner-item';
  const formSubmitTracking = 'data-form-submit-tracking';

  function initSelectors(el) {
    $element = el;
    $toggleDropDown = $element.querySelectorAll(toggleDropDownClassSelector);
    $navDropDown = $element.querySelectorAll(navDropdownClassSelector);
    $searchForm = $element.querySelector(searchFormSelector);
    $searchSubmitBtn = $element.querySelector(searchSubmitBtnSelector);
    $navActionContainer = $element.querySelector(acrNavActionContainerSelector);
    $geoForm = $element.querySelector(geoFormSelector);
    $geoZipInput = $element.querySelector(acrNavGeoInputSelector);
    $geoZipButton = $element.querySelector(acrNavGeoButtonSelector);
    $body = document.querySelector(bodyTagSelector);
    $currentZip = $element.querySelector(currentZipSelector);
    $navSearch = document.getElementById(navSearchSelector);

    $acrNotificationContainer = $element.querySelector(acrNotificationContainerSelector);
    $acrNotificationBannerItems = $element.querySelectorAll(acrNotificationBannerItemSelector);
    $acrNotificationPagination = $element.querySelector(acrNotificationPaginationSelector);
    $arrowLeft = $element.querySelector(arrowLeftSelector);
    $arrowRight = $element.querySelector(arrowRightSelector);
  }

  // Close Menu
  function closeMenu(el) {
    closeSubMenu(el);
    setClosedState(el);
  }

  // Set Closed State (Only necessary for Desktop)
  function setClosedState(el) {
    $body.classList.remove(modalOpenClassName);
    el.classList.remove(acrNavShadowClassName);
  }

  // Set Opened State (Only necessary for Desktop)
  function setOpenedState(el) {
    $body.classList.add(modalOpenClassName);
    el.classList.add(acrNavShadowClassName);
  }

  // Bind Menu Toggle events (Open/ Close)
  function toggleMenu(el) {
    document.addEventListener('click', function (event) {
      var self;
      var mappedSelf;
      self = event.target;

      if (self.getAttribute) {
        mappedSelf = self.getAttribute('class')
          && self.getAttribute('class').search(toggleBarClassSelector) > 0
          ? self : undefined || self.closest(toggleBarClassSelector);
      }

      if (!mappedSelf) return;

      if (el.classList.contains(acrNavExpandedClassName)) {
        el.classList.remove(acrNavExpandedClassName);
        $body.classList.remove(noScrollSmall);
        $body.classList.remove(modalOpenClassName);
        closeSubMenu(el);
        setClosedState(el);
      } else {
        el.classList.add(acrNavExpandedClassName);
        $body.classList.add(noScrollSmall);
      }
    });
  }

  // When Shadow is clicked menu must close
  function toggleShadowMenu(el) {
    document.addEventListener('click', function (event) {
      var self;
      var mappedSelf;
      self = event.target;

      if (self.getAttribute) {
        mappedSelf = self.getAttribute('class')
          && self.getAttribute('class').search(shadowSelector) > 0
          ? self : undefined || self.closest(shadowSelector);
      }

      if (mappedSelf) {
        closeMenu(el);
      }
    });
  }

  // Bind Sub Menus Toggle events (Open/ Close)
  function toggleSubMenu(el) {
    document.addEventListener('click', function (event) {
      var self;
      var mappedSelf;
      var $target;
      var targetId;

      event.stopPropagation();

      self = event.target;

      if (self.getAttribute) {
        mappedSelf = self.getAttribute('class')
          && self.getAttribute('class').search(toggleDropDownClassSelector) > 0
          ? event.target : undefined || self.closest(toggleDropDownClassSelector);
      }

      if (!mappedSelf) return;
      targetId = mappedSelf.getAttribute('href');
      $target = document.querySelector(targetId);

      if ($target.classList.contains(acrNavDropdownExpandedClassName)) {
        closeSubMenu(el);
        $target.classList.remove(acrNavDropdownExpandedClassName);
        mappedSelf.classList.remove(acrNavItemLinkExpandedClassName);
        setClosedState(el);

      } else {
        closeSubMenu(el);
        $target.classList.add(acrNavDropdownExpandedClassName);
        mappedSelf.classList.add(acrNavItemLinkExpandedClassName);
        setOpenedState(el);
      }
    });
  }

  // Bind Lang Choser Toggle events (Open/ Close)
  function toggleLangMenu(el) {
    document.addEventListener('click', function (event) {
      var self;
      var mappedSelf;
      self = event.target;

      if (self.getAttribute) {
        mappedSelf = self.getAttribute('class')
          && self.getAttribute('class').search(toggleLangChooserBtnSelector) > 0
          ? self : undefined || self.closest(toggleLangChooserBtnSelector);
      }

      if (!mappedSelf) return;

      if (!el.classList.contains(acrNavLangExpandedClassName)) {
        closeSubMenu(el);
        el.classList.add(acrNavLangExpandedClassName);
        setOpenedState(el);

      } else {
        closeSubMenu(el);
        el.classList.remove(acrNavLangExpandedClassName);
        setClosedState(el);
      }
    });
  }


  // Bind Search Toggle events (Open/ Close)
  function toggleSearch(el) {
    document.addEventListener('click', function (event) {
      var self;
      var mappedSelf;
      self = event.target;

      if (self.getAttribute) {
        mappedSelf = self.getAttribute('class')
          && self.getAttribute('class').search(searchBtnSelector) > 0
          ? self : undefined || self.closest(searchBtnSelector);
      }

      if (!mappedSelf) return;

      if (!el.classList.contains(acrNavSearchExpandedClassName)) {
        closeSubMenu(el);
        el.classList.add(acrNavSearchExpandedClassName);
        $navSearch.focus();
        setClosedState(el);
      } else {
        closeSubMenu(el);
        el.classList.remove(acrNavSearchExpandedClassName);
        setClosedState(el);
      }
    });
  }

  function closeGeo() {
    $element.classList.remove(acrNavGeoExpandedClassName);
    $geoForm.classList.remove(noValidClassName);
    $geoZipInput.classList.remove(noValidClassName);
    $geoZipInput.value = '';
    setClosedState($element);
  }

  // Bind Search Toggle events (Open/ Close)
  function toggleGeo(el) {
    document.addEventListener('click', function (event) {
      var self;
      var mappedSelf;
      self = event.target;

      if (!observer) {
        observer = new IntersectionObserver(inputObserverHandler);
      }

      if (self.getAttribute) {
        mappedSelf = self.getAttribute('class')
          && self.getAttribute('class').search(geoBtnSelector) > 0
          ? self : undefined || self.closest(geoBtnSelector);
      }

      if (!mappedSelf) return;

      if (!el.classList.contains(acrNavGeoExpandedClassName)) {
        closeSubMenu(el);
        el.classList.add(acrNavGeoExpandedClassName);
        $geoZipButton.disabled = true;
        $geoZipInput.focus();
        setClosedState(el);
      } else {
        closeSubMenu(el);
        closeGeo();
        observer.unobserve($geoZipInput);
      }
    });
  }

  // Close all SubMenu Items - Includes Lang Chooser
  function closeSubMenu(el) {

    el.classList.remove(acrNavLangExpandedClassName);

    for (var i = 0; i < $toggleDropDown.length; i++) {
      $toggleDropDown[i].classList.remove(acrNavItemLinkExpandedClassName);
    }

    for (var j = 0; j < $navDropDown.length; j++) {
      $navDropDown[j].classList.remove(acrNavDropdownExpandedClassName);
    }
  }

  function onSubmitSearchForm() {
    $searchForm.addEventListener('submit', function (e) {
      if (e.target.querySelector(acrNavInputSelector).value === '') {
        e.preventDefault();
        $searchForm.classList.add(noValidClassName);
        return;
      }

      var stringObject = $searchSubmitBtn.hasAttribute(formSubmitTracking) ? $searchSubmitBtn.getAttribute(formSubmitTracking) : '';
      if (Acr.TrackingManager && stringObject) {
        try {
          var object = JSON.parse(stringObject.split("'").join('"'));
          Acr.TrackingManager.clickActivity(object);
        } catch (err) {
          console.warn('ERROR AT TRACKING OBJECT: ' + err);
        }
      }
    });
  }

  function updateGeoZipCodeUI(zipCode) {
    $currentZip.innerText = zipCode;
  }

  function updateGeoZipCode(zipcode) {
    zipcodeUpdateEvent = utility.createEvent(zipcodeUpdateEventName, { zipcode: zipcode });
    utility.setCookie('zipcode', zipcode);
    window.dispatchEvent(zipcodeUpdateEvent);
    updateGeoZipCodeUI(zipcode);
  }

  function onChangeGeoForm() {
    $geoZipInput.addEventListener('input', function (event) {
      var inputValue = this.value;
      var antiRegex = new RegExp(/[^0-9]+/g);
      var validZipcode = new RegExp(/^\d{5}$/);

      $geoForm.classList.remove(noValidClassName);
      $element.classList.remove(acrNavGeoErrorClassName);

      this.value = inputValue.replace(antiRegex, '');
      if (inputValue.match(validZipcode)) {
        $geoZipButton.disabled = false;
      } else {
        $geoZipButton.disabled = true;
      }
    });
  }

  function showGeoFormError() {
    $geoForm.classList.add(noValidClassName);
    $element.classList.add(acrNavGeoErrorClassName);
  }

  function validZipcodeSubmit() {
    var inputValue = $geoZipInput.value;
    updateGeoZipCode(inputValue);
    closeGeo();
  }

  function onSubmitGeoForm() {
    var inputValue;

    if ($geoForm.addEventListener) {
      $geoForm.addEventListener('submit', function (event) {
        event.preventDefault();
        inputValue = $geoZipInput.value;
        Utility.validateZipcode(inputValue, validZipcodeSubmit, showGeoFormError);
      }, true);
    }
  }

  function initZipcode() {
    var zipcode;

    window.addEventListener('zipcodeUpdate', function (event) {
      updateGeoZipCodeUI(event.detail.zipcode);
    });

    zipcode = utility.getUrlParameterValue('zipcode') || utility.getCookie('zipcode');
    if (zipcode) {
      updateGeoZipCode(zipcode);
    }
  }

  function onClickLocationbtn() {
    document.addEventListener('click', function (event) {
      var self;
      var mappedSelf;
      self = event.target;

      if (self.getAttribute) {
        mappedSelf = self.getAttribute('class')
          && self.getAttribute('class').search(openZipGateSelector) > 0
          ? self : undefined || self.closest(openZipGateSelector);
      }

      if (mappedSelf) {
        Acr.zipgateComponent.openZipgate();
        $element.classList.remove(acrNavExpandedClassName);
        $body.classList.remove(noScrollSmall);
        $body.classList.remove(modalOpenClassName);
        closeGeo();
        closeSubMenu($element);
        setClosedState($element);
      }
    });
  }


  function onGeoZipInputFocus() {
    if (utility.isAndroid()) {
      $geoZipInput.addEventListener('focus', function () {
        $navActionContainer.style.paddingBottom = '6rem';
        observer.observe($geoZipInput);
      });
    }
  }

  function inputObserverHandler(entries, observer) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) {
        observer.unobserve($geoZipInput);
        window.setTimeout(function () {
          $geoZipButton.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }, 500);
      }
    });
  }

  function bindEvents(el) {
    toggleMenu(el);
    toggleShadowMenu(el);
    toggleSubMenu(el);
    toggleLangMenu(el);
    toggleSearch(el);
    toggleGeo(el);
    initZipcode();
    onChangeGeoForm();
    onSubmitSearchForm();
    onSubmitGeoForm();
    onClickLocationbtn();
    onGeoZipInputFocus();
  }

  function initNotificationBanner(el) {

    if ($acrNotificationContainer && $acrNotificationBannerItems.length > 1) {

      $acrNotificationBannerSwiper = new Swiper($acrNotificationContainer, {
        // Optional parameters
        loop: false,
        // If we need pagination
        pagination: {
          el: $acrNotificationPagination,
          type: 'fraction',
        },
        // Navigation arrows
        navigation: {
          nextEl: $arrowRight,
          prevEl: $arrowLeft,
        },
        init: true,
      });
      $acrNotificationPagination.childNodes[1].nodeValue = ' of ';
    }
  }

  function init(el) {
    initSelectors(el);
    bindEvents(el);
    initNotificationBanner(el);
  }

  return {
    init: init,
  };
};
